export default class TimelineGame{
    constructor(logo, title, description, year, image){
        this.logo = logo; 
        this.title = title;
        this.description = description;
        this.year = year;
        this.image = image;
    }
}
